import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerTitle: {
            fontWeight: 600,
            fontSize: 24,
            marginBottom: theme.spacing(3),
        },
        bodyHeader: {
            padding: theme.spacing(2),
        },
        intro: {
            fontSize: 16,
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(2),
        },
        toolbox: {
            display: "flex",
            alignItems: "center",
        },
        filtersWrapper: {
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
            "& > div": {
                display: "flex",
                flex: 1,
                alignItems: "flex-start",
                flexDirection: "column",
            },
        },
        label: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(0.5),
        },
        filterByNameInput: {
            width: "100%",
            "& .MuiInputBase-input": {
                height: 22,
            },
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
        selectField: {
            width: "100%",
            "& .MuiSelect-select": {
                paddingTop: theme.spacing(2.7),
                paddingBottom: theme.spacing(2.7),
                "& .MuiChip-root": {
                    height: 20,
                    "& .MuiChip-label": {
                        fontSize: 10,
                        paddingLeft: theme.spacing(0.75),
                        paddingRight: theme.spacing(0.75),
                    },
                },
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        filterPlaceholderLabel: {
            color: theme.palette.text.disabled,
        },
        selectMenuItem: {
            padding: theme.spacing(1),
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 400,
                color: theme.palette.text.primary,
            },
            "&.Mui-selected": {
                "& .MuiListItemText-primary": {
                    fontWeight: 700,
                },
            },
        },
        selectFilterPaper: {
            borderRadius: theme.spacing(3),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
        },
        selectMenuClear: {
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 2, 1, 2),
        },
        permissionCount: {
            backgroundColor: "#00000014",
            borderRadius: theme.spacing(10),
            padding: theme.spacing(0.5),
            lineHeight: 1,
            fontSize: 10,
            width: 20,
            height: 20,
        },
        tableHeader: {
            background: theme.palette.background.paleBlue,
            "& .MuiTableCell-root": {
                fontWeight: 700,
                borderBottom: `1px solid ${theme.palette.neutrals.main}`,
                padding: theme.spacing(1.4),
                "& .MuiTypography-root": {
                    fontSize: 16,
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                },
                "&:first-child": {
                    paddingLeft: theme.spacing(2),
                },
                "&:last-child": {
                    paddingRight: theme.spacing(2),
                },
            },
        },
        cellWithSortButton: {
            display: "flex",
            alignItems: "center",
            marginLeft: -8,
        },
        sortButton: {
            fontSize: 14,
            color: theme.palette.neutrals.dark,
        },
        columnsButton: {
            color: theme.palette.button.active.to,
        },
        tableBody: {
            "& .MuiTableCell-root": {
                color: theme.palette.text.secondary,
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
                padding: theme.spacing(2.2, 1.4),
                "&[data-hidden='true']": {
                    display: "none",
                },
                "&:first-child": {
                    paddingLeft: theme.spacing(2.5),
                },
                "&:last-child": {
                    paddingRight: theme.spacing(2),
                },
            },
        },
        hyperlink: {
            display: "flex",
            alignItems: "center",
            letterSpacing: "1.25px",
            color: theme.palette.secondary.main,
            "& .MuiSvgIcon-root": {
                fontSize: 14,
            },
            "& .MuiTypography-root": {
                marginLeft: theme.spacing(0.8),
            },
        },
        noDataWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: theme.spacing(-5, 0, 4),
            "& .MuiTypography-root": {
                fontSize: 16,
                marginBottom: theme.spacing(2),
                "& + .MuiTypography-root": {
                    fontSize: 14,
                    color: theme.palette.text.secondary,
                    marginTop: theme.spacing(-1.5),
                },
            },
        },
    })
);

export default useStyles;
